export default __webpack_public_path__ + "static/media/Virtual3-mobi.51e7f11b.webp";